import * as React from 'react';
import api from './ApiClient';
import Duration from './Duration';
import moment from 'moment';
import Security from './Security';

import './LapColors.scss';

interface ResultsTableProps {	
	results: any,
	showETA: boolean,
	checkpointDataChanged: () => void,
	race: any,
};

export default class CompetitorDetails extends React.Component<ResultsTableProps, any> {

	componentDidMount() {	
		
	}

	state = {
		results: []
	};

	deleteCheckpoint = (checkpoint) => {
		api.delete('checkpoints/delete/' + checkpoint.id).then(response => {
			this.props.checkpointDataChanged();
		});
	}

	undeleteCheckpoint = (checkpoint) => {
		api.put('checkpoints/undelete/' + checkpoint.id,null).then(response => {
			this.props.checkpointDataChanged();
		});
	}

	splitCheckpoint = (checkpoint) => {
		api.post('checkpoints/split/' + checkpoint.id, null).then(response => {
			this.props.checkpointDataChanged();
		});
	}



	render() {
		return (
			<div>
				{this.props.results.map((result, index) => {
					// Get the last non-deleted checkpoint
					var lastLap = result.checkpoints
						.filter(checkpoint => !checkpoint.deleted)
						.slice(-1)[0];

					// Only calculate these if we have a valid lastLap
					let estimatedLapsRemaining = null;
					let etaTime = null;

					if (lastLap) {
						// Calculate race end time and remaining laps
						const raceEndTime = moment(this.props.race.start).add(this.props.race.duration, 'minutes');
						const timeRemaining = raceEndTime.diff(moment());
						estimatedLapsRemaining = timeRemaining > 0 ? Math.floor(timeRemaining / lastLap.laptime) : 0;

						// Calculate the actual ETA time
						etaTime = moment(lastLap.timestamp).add(lastLap.laptime, 'ms');
					}

					return (
						<div key={result.competitor.id}>
							<h2>#{result.position} - {result.competitor.name}</h2>
							{this.props.showETA && lastLap && (
								<h3>ETA: {etaTime.fromNow()} ({etaTime.format("HH:mm:ss")})</h3>
							)}
							{this.props.showETA && lastLap && (
								<h3>Estimated laps remaining: {estimatedLapsRemaining}</h3>
							)}

							<table className="table table-striped">
								<thead>
									<tr>
										<th colSpan={5}></th>
										<th colSpan={2} className="text-center table-info">Gap</th>									
										<th colSpan={2} className="text-center table-primary">Lap times diff</th>
									</tr>
									<tr>
										<th>Lap</th>
										<th>Pos</th>
										<th className="text-right">Lap Time</th>
										<th className="text-right">Race Time</th>
										<th className="text-right">Day Time</th>
										<th className="text-right table-info">First</th>
										<th className="text-right table-info">Next</th>
										<th className="text-right table-primary">First</th>
										<th className="text-right table-primary">Next</th>
										{Security.isAdmin() && [
												<th className="table-warning">Source</th>,
												<th className="table-warning">Actions</th>
										]}
									</tr>
								</thead>
								<tbody>
									{result.checkpoints.map((checkpoint, index) => {
										var rowStyle = {};
										if (checkpoint.deleted) {
											rowStyle['textDecoration'] = 'line-through';
											rowStyle['color'] = 'red';
										}
										if (!checkpoint.deleted || Security.isAdmin()) return (
											<tr key={checkpoint.timestamp} style={rowStyle}>
												<td className="">{checkpoint.lapNumber}</td>
												<td>
													{checkpoint.pos}
													{checkpoint.posDiff > 0 && <i className="fas fa-sort-up text-success"></i>}
													{checkpoint.posDiff < 0 && <i className="fas fa-sort-down text-danger"></i>}
												</td>

												<td className={['text-right', checkpoint.fastestLap ? 'fastestLapTime' : (checkpoint.bestLap ? 'personalBestTime' : '')].join(' ')}
													title={checkpoint.fastestLap ? 'Fastest lap of the race' : (checkpoint.bestLap ? "Competitor's best lap" : undefined)}>
													{Duration(checkpoint.laptime).format()}
												</td>

												<td className="text-right">
													{Duration(moment(checkpoint.timestamp).diff(moment(this.props.race.start))).format()}
												</td>

												<td className="text-right">
													{moment(checkpoint.timestamp).format("HH:mm:ss")}
												</td>

												<td className="text-right table-info">{checkpoint.behindFirst ? Duration(checkpoint.behindFirst).format() : '--'}</td>
												<td className="text-right table-info">{checkpoint.behindNext ? Duration(checkpoint.behindNext).format() : '--'}</td>

												<td className="text-right table-primary">{checkpoint.laptimeDiffFromFirst ? Duration(checkpoint.laptimeDiffFromFirst).format() : ''}</td>
												<td className="text-right table-primary">{checkpoint.laptimeDiffFromNext ? Duration(checkpoint.laptimeDiffFromNext).format() : ''}</td>


												{Security.isAdmin() && [
													<th className="table-warning">{checkpoint.source}</th>,
													<th className="table-warning">
														{checkpoint.deleted && <button onClick={(e) => this.undeleteCheckpoint(checkpoint)}>Undelete</button>}
														{!checkpoint.deleted && <button onClick={(e) => this.deleteCheckpoint(checkpoint)}>Delete</button>}
														<button onClick={(e) => this.splitCheckpoint(checkpoint)}>Split</button>
													</th>
												]}
											</tr>
										);}
									)}
								</tbody>
							</table>

						</div>
					)}
				)}
			</div>			
		)
	}
}